

function dynamicAddScript(url,isAsync=true,isHead = false) {
  var my_awesome_script = document.createElement('script');
  if(isAsync){
    my_awesome_script.async = 1
  }
  my_awesome_script.setAttribute('src', url);
  document.body.appendChild(my_awesome_script);
  return my_awesome_script
}
function dynamicAddStyle(url) {
  var stylesheet = document.createElement('link');
  stylesheet.rel = 'stylesheet';
  stylesheet.href= url;
  document.head.appendChild(stylesheet);
  return stylesheet;
}


export default{
  dynamicAddScript,
  dynamicAddStyle
}

if(process.env.VUE_ENV!='server'){  //非服务端渲染才添加
  //为全局添加Element的documentOffsetTop功能
  if (!Element.prototype.hasOwnProperty('documentOffsetTop')) {
    window.Object.defineProperty(Element.prototype, 'documentOffsetTop', {
      get: function() {
        return this.offsetTop + (this.offsetParent ? this.offsetParent.documentOffsetTop : 0);
      }
    });

    window.Object.defineProperty(Element.prototype, 'documentOffsetLeft', {
      get: function() {
        return this.offsetLeft + (this.offsetParent ? this.offsetParent.documentOffsetLeft : 0);
      }
    });
  }
}
